export default {
  getShow: state => {
    if (localStorage.getItem('tabbarStatus')) {
      state.show = localStorage.getItem('tabbarStatus') === "show" ? true : false;
    }
    return state.show;
  }
}



// WEBPACK FOOTER //
// ./src/_store/modules/tabBar/getters.js